module.exports = __webpack_public_path__ + "img/icon_map_188_off_111.e94be850.png";